import { CityModel } from 'src/app/models/management/city.model';
export class CompanyCityModel {
  companyCityId: number = 0;
  companyId: number = 0;
  cityId: number = 0;
  city: CityModel = new CityModel();
  alterCode: string = '';
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
